import React, { ReactElement } from 'react';
import { useCollapse } from '../../providers/useCollapse';

import { TransitionProps } from '../Transition.types';

/** Toggle is a component to solve ReactTransitionGroup bug with lagging collapse and expand transitions. */
const Toggle = ({
  children,
  className,
  dataHook,
  mountOnEnter,
  show,
  timeout,
  unmountOnExit,
  onEnd,
  onStart,
}: TransitionProps & { timeout: number; className?: string }): ReactElement => {
  const { getCollapseProps, exitAnimationEnded } = useCollapse({
    isExpanded: show,
    duration: process.env.NODE_ENV === 'test' ? 0 : timeout,
    onCollapseStart: onEnd,
    onExpandStart: onStart,
  });

  return (
    <div data-hook={dataHook} {...getCollapseProps({ className })}>
      {!show &&
      (unmountOnExit || (mountOnEnter && unmountOnExit === false)) &&
      exitAnimationEnded
        ? null
        : children}
    </div>
  );
};

Toggle.displayName = 'Toggle';

export { Toggle };
